/** Stable string for comparing team assignments (order-independent). */
import type { TeamId } from "../interface/GameTypes";

export function teamAssignmentKey(players: ReadonlyArray<{ uuid: string; teamId: TeamId }>): string {
  return [...players]
    .sort((a, b) => a.uuid.localeCompare(b.uuid))
    .map((p) => `${p.uuid}:${p.teamId}`)
    .join("|");
}
